import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

export const i18n = new VueI18n({
    locale: 'en',
    messages: {
        en: {
            title: 'Lifecycle Automations to Keep and Convert Your Customers',
            subtitle: 'Create email automations (and more!) to improve each stage of your funnel. Perfect for onboarding, nurturing, and converting customers.',
            feature: {
                engagement: {
                    headline: 'Create simple email onboarding workflows to educate customers and engage them at key moments to drive engagement, sales, and referrals.',
                },
                management: {
                    headline: 'Manage your customers with a customer data platform. With CrowdPower, you’ll know who your best customers are and which ones are close to converting.',
                },
                segmenting: {
                    headline: 'Create segments based on who your customers are and what they did (or didn’t do) to send personalized messages that convert them at the right times.',
                },
                email: {
                    headline: 'Compose emails with our custom-built drag-and-drop email builder. Send personalized messages to your customers in bulk based on the actions they take on your application.',
                },
            },
            testimonial: {
                partnered: {
                    quote: 'CrowdPower is easy to get started with and let’s you jump into building flows right away. It doesn’t feel like there is a learning curve.',
                    name: 'Tim',
                    title: 'CTO',
                    company: 'Partnered',
                    link: 'https://partnered.com',
                    photo: '/img/testimonials/testimonial-photo4.jpg',
                },
                helplk: {
                    quote: 'When you need a custom feature or integration, directly contact the team and get it done. Support is 100x than the industry average.',
                    name: 'Harsha',
                    title: 'CEO',
                    company: 'Help.lk',
                    link: 'https://help.lk',
                    photo: '/img/testimonials/testimonial-photo2.jpg',
                },
                pr24: {
                    quote: 'I really like CrowdPower’s segmentation options. This useful and powerful feature enables us to segment our customers according to different attributes.',
                    name: 'Marianne',
                    title: 'CEO',
                    company: 'pr24',
                    link: 'https://pr24.ch',
                    photo: '/img/testimonials/testimonial-photo1.jpg',
                },
                peterteszary: {
                    quote: 'The capability of this product is endless. Really easy to build automations. The drag and drop email builder is just fantastic.',
                    name: 'Peter',
                    title: 'Web Developer',
                    company: 'peterteszary.com',
                    link: 'https://peterteszary.com',
                    photo: '/img/testimonials/testimonial-photo3.jpg',
                },
            }
        },
    },
});